import BaseApi from "../../../services/Api";
import Swal from "sweetalert2";
import React, {useEffect, useState} from "react";
import Tooltip from "../../Popups/Tooltip";
import {Modal, Spinner} from "react-bootstrap";
import { format } from "date-fns";
import ptBR from 'date-fns/locale/pt-BR';


const ModalDonationInfo = ({
  idDonation, children
}) => {
  const [isLoading, setLoading] = React.useState(true);
  const [isSaving, setSaving] = React.useState(true);
  const [isShow, setShowModal] = React.useState(false);

  const [name, setName] = useState('');
  const [moreInfo, setMoreInfo] = useState('');
  const [description, setDescription] = useState('');
  const [creationDate, setCreationDate] = useState('');
  const [icon, setIcon] = useState(null);


  const handleClose = () => {
    setShowModal(false);
  }

  const requestData = () => {
    setLoading(true);
    BaseApi.get(`/doacoes/${idDonation}`).then(res => {
      let data = res.data;
      setName(data.name);
      setMoreInfo(data.moreInfo);
      setDescription(data.description);
      setIcon(data.icon);
      setCreationDate(data.created_at);
      setLoading(false);
      setSaving(false);
    }).catch(err => {
      console.log(err);
      Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || 'Ocorreu um erro ao carregar este usuario ou o usuário não foi encontrado.', 'error');
      setShowModal(false);
    })
  }

  useEffect(() => {
    if(isShow) {
      requestData();
    } else {
      setName('');
      setMoreInfo('');
      setDescription('');
      setIcon(null);
      setLoading(true);
      setSaving(true);
    }
  }, [isShow])

  return (
    <>
      {children &&
        React.cloneElement(children, { onClick: (e) => setShowModal(true) })}
      {!children && (
        <Tooltip text={"Informações da Doação"}>
          <button
            className={`btn btn-${idDonation ? "warning" : ""} text-white fa-bold`}
            onClick={(e) => setShowModal(true)}
          >
            <i className={`bi bi-${idDonation ? "person-gear" : "plus"}`}></i>
          </button>
        </Tooltip>
      )}
      <Modal
        centered
        scrollable
        onHide={handleClose}
        show={isShow}
        animation={true}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Informações da Doação</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-center">
            {isLoading && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
          </div>
          {!isLoading && (
            <>
              <div className="row">
                
                <div className="form-group mb-3">
                  <label htmlFor="name">Nome</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="Insira o nome"
                    value={name}
                  readonly/>
                </div>

                <div className="form-group mb-3">
                  <div>
                    <label  htmlFor="name">Description </label> 
                    <textarea readOnly 
                      name="text" 
                      id="description" 
                      cols="30" 
                      rows="5"
                      className="form-control"
                      placeholder="Insira a descrição"
                      value={description}
                      
                    />
                  </div>
                </div>


                <div className="form-group mb-3">
                  <label htmlFor="link">Informações Adicionais </label>
                  <input
                    type="text"
                    className="form-control"
                    id="link"
                    placeholder="Link"
                    value={moreInfo}
                   
                  readonly/>
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="creationDate">Data de criação</label>
                  <input
                    type="creationDate"
                    className="form-control"
                    id="creationDate"
                    value={format(new Date(creationDate), "d 'de' MMMM 'de' yyyy 'às' H:mm", { locale: ptBR })}
                   
                  readonly/>
                </div>
                

                <div className="form-group mb-3">
                  <label htmlFor="icon">Ícone</label>

                
                  
                  {idDonation ? (
                    <div className="d-flex justify-content-center align-items-center mt-2">
                      <img
                        src={icon instanceof File ? URL.createObjectURL(icon) : icon}
                        alt="icon"
                        style={{ minWidth: 250, width: 350, objectFit: 'cover' }}
                      />
                    </div>
                  ) : 
                    null
                  }

                  {icon && !idDonation && (
                    <div className="d-flex justify-content-center align-items-center mt-2">
                      {idDonation ? <img src={icon} alt="icon" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                        : <img src={URL.createObjectURL(icon)} alt="icon" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                      }
                      </div>
                    )
                  }
                </div>


              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center w-100">
            <div className="d-block me-auto"></div>
            <div className="d-block ms-auto">
              <button
                className="btn btn-danger text-white me-2"
                onClick={handleClose}
              >
                Close
              </button>
             
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalDonationInfo;